var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.5 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,10.5h0A4.5,4.5,0,0,1,25,15V48.5A4.5,4.5,0,0,1,20.5,53h0a2,2,0,0,1-2-2V12.5a2,2,0,0,1,2-2Z",
    transform: "translate(53.5 10) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,29.08h0a2.43,2.43,0,0,1-2.42,2.42H15.92a2.43,2.43,0,0,1-2.42-2.42h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.5,
    y1: 13.13,
    x2: 40.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,28.5V10A2.46,2.46,0,0,1,6,7.5h6.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41,10.5H34l-3.52,4v-4H30A1.52,1.52,0,0,1,28.5,9V2A1.52,1.52,0,0,1,30,.5H41A1.52,1.52,0,0,1,42.5,2V9A1.52,1.52,0,0,1,41,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.5,26.5c0-3,1-4,3-5a47.09,47.09,0,0,1,5-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.5,20.5c-2,0-3-1-3-2V15.27h0a3.06,3.06,0,0,1-2-2.77v-5c0-1,1-4,5-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.5,26.5c0-3-1-4-3-5a47.09,47.09,0,0,0-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.5,20.5c2,0,3-1,3-2V15.27h0a3.06,3.06,0,0,0,2-2.77v-5c0-1-1-4-5-4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.211a334b35abc836df05548d92c8d86c.svg";
export { ForwardRef as ReactComponent };